"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _NumberInput = _interopRequireDefault(require("../NumberInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PercentageInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PercentageInput, _React$PureComponent);

  var _super = _createSuper(PercentageInput);

  function PercentageInput() {
    _classCallCheck(this, PercentageInput);

    return _super.apply(this, arguments);
  }

  _createClass(PercentageInput, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_NumberInput.default, this.props);
    }
  }]);

  return PercentageInput;
}(_react.default.PureComponent);

_defineProperty(PercentageInput, "propTypes", {
  /** Alignment of the input area - primarily used when doing split layouts */
  aligninput: _propTypes.default.oneOf([undefined, 'left', 'right', 'center']),

  /** Flag for toggling integers and floats (defaults to false) */
  allowDecimal: _propTypes.default.bool,

  /** Flag for allowing leading zeroes, unsurprisingly (defaults to false) */
  allowLeadingZeroes: _propTypes.default.bool,

  /** Autofocus flag */
  autoFocus: _propTypes.default.bool,

  /** Children can be any valid node or array of valid nodes */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Set a limit on decimals. Null will set to unlimited. (defaults to 2) */
  decimalLimit: _propTypes.default.number,

  /** Flag used to disable the input */
  disabled: _propTypes.default.bool,

  /** Flag used for inidcating an error state for the input */
  error: _propTypes.default.string,

  /** Flag used to toggle the thousands separator (defaults to true) */
  includeThousandsSeparator: _propTypes.default.bool,

  /** Flag used to limit the length of the integer */
  inputType: _propTypes.default.string,

  /** Flag used to limit the length of the integer */
  integerLimit: _propTypes.default.number,

  /** Label for Input */
  label: _propTypes.default.string,

  /** Layout modifier */
  layout: _propTypes.default.oneOf([undefined, 'split']),
  // ICONS

  /** Icons or IconButtons to display to the left of the input field. */
  leftIcons: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element])),

  /** Icons or IconButtons to display to the right of the input field. */
  rightIcons: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element])),

  /** Maximum accepted value for numeric inputs */
  maximumValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /** Minimum accepted value for numeric inputs */
  minimumValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /** name reference for label htmlFor */
  name: _propTypes.default.string,

  /** Allows a prefix for currency (or whatever you'd like) in the input field (defaults to '') */
  prefix: _propTypes.default.string,

  /** Allows a suffix for percentage (or anything really) in the input field (defaults to '') */
  suffix: _propTypes.default.string,

  /** Additional validation rules to apply */
  validationRules: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]))),

  /** This is the storage location for the value of the input */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  // EVENTS

  /** Function to invoke on a blur event */
  onBlur: _propTypes.default.func,

  /** Function to invoke on a change event */
  onChange: _propTypes.default.func,

  /** Function to invoke on a click event */
  onClick: _propTypes.default.func,

  /** Function to invoke on a focus event */
  onFocus: _propTypes.default.func,

  /** Function to invoke on a keyUp event */
  onKeyUp: _propTypes.default.func
});

_defineProperty(PercentageInput, "defaultProps", {
  allowDecimal: false,
  aligninput: undefined,
  allowLeadingZeroes: false,
  autoFocus: false,
  children: null,
  className: '',
  decimalLimit: 0,
  disabled: false,
  error: '',
  includeThousandsSeparator: false,
  inputType: 'tel',
  integerLimit: 3,
  label: '',
  layout: undefined,
  // icons
  leftIcons: [],
  rightIcons: [/*#__PURE__*/_react.default.createElement(_Icon.default, {
    dataTestId: "percentage-input-percent-icon",
    iconName: "percent",
    size: "small",
    colorTheme: "primary"
  })],
  maximumValue: 100,
  minimumValue: 0,
  name: '',
  prefix: '',
  suffix: '',
  validationRules: {},
  // event handlers
  onBlur: function onBlur() {},
  onChange: function onChange(e) {
    return e.target.value;
  },
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onKeyUp: function onKeyUp() {}
});

var _default = PercentageInput;
exports.default = _default;